import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/detect/ADetectUvSuggest/index", {
        params: {
            ...params
        }
    } )
}
function EDIT_DATA(params) {
    return  axios.post("/detect/ADetectUvSuggest/edit", {id:params})
}
function SUBMIT_ADD(params) {
    return  axios.post("/detect/ADetectUvSuggest/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/detect/ADetectUvSuggest/editPost",{...params} )
}


function CHANG_STATUS (params) {
    return  axios.post("/detect/ADetectUvSuggest/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/detect/ADetectUvSuggest/delete",{
        params: {
            ids:params
        }
    } )
}

function ADD_DATA_UA(params) {
    return  axios.post("/detect/ADetectUvSuggest/manyYears",{  } )
}
function SUBMIT_ADD_UV(params) {
    return  axios.post("/detect/ADetectUvSuggest/manyYearsPost",{...params} )
}
export default {
    GET_LIST,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
    SUBMIT_ADD_UV,
    ADD_DATA_UA
}